export const register = {
    fullName: {
        name: 'ชื่อ - นามสกุล (ตามที่แสดงบนบัตรประชาชน)',
        placeholder: 'กรอกชื่อ - นามสกุล',
        required: 'กรุณากรอกชื่อ - นามสกุล',
        too_short: '',
        invalid: '',
    },
    contactNumber: {
        name: 'เบอร์โทรศัพท์มือถือ',
        placeholder: 'กรอกเบอร์โทรศัพท์มือถือ',
        required: 'กรอกเบอร์โทรศัพท์มือถือ',
        too_short: 'กรุณาระบุหมายเลขโทรศัพท์มือถือให้ครบ 10 หลัก',
        invalid: 'เบอร์โทรศัพท์ไม่ถูกต้อง',
    },
    prefixName:{
        name: 'คำนำหน้า',
        required: 'กรุณาเลือกคำนำหน้า',
    }
}